import { gql } from '@src/lib/gql'

/**
 * The on-site chat composer's CRM lookup (crm-chat-draft-sync D4): for a crm account's own CRM
 * conversation, its reply tool, the member message a reply answers, who is working the reply, and the
 * shared reply draft with its files. Null when the thread is not the account's CRM conversation.
 */
export const CRM_CHAT_DRAFT = gql`
  query CrmChatDraft($threadId: String!) {
    crmChatDraft(threadId: $threadId) {
      threadId
      accountUserId
      toolId
      inboundCommentId
      seenInboundCommentId
      claimOwnerUserId
      claimOwnerDisplayName
      claimOwnedByViewer
      claimExpiresAt
      draft {
        commentId
        body
        draftEdited
        draftGeneratedAt
        storedFiles {
          storedFileId
          title
          fullUrl
          mimeType
          deletedAt
        }
      }
    }
  }
`

/**
 * Whether the signed-in person is a crm account. Its own small query, not the shared currentUser one:
 * an API without the field fails only this, and the composer simply stays plain.
 */
export const CHAT_CRM_ACCOUNT = gql`
  query ChatCrmAccount {
    currentUser {
      id
      userId
      crmEnabled
    }
  }
`
